<template>
  <loading-overlay v-if="loading" class="animated fadeIn" />

  <div v-else class="animated fadeIn mb-4">
    <default-heading class="mt-3">
      {{ submission.pid }}
    </default-heading>

    <div class="mt-3" />

    <b-row>
      <b-col>
        <b-card>
          <div>
            <b-table-lite
              :items="submissionInfoRows"
              striped
              small
              bordered
              thead-class="d-none"
            />
          </div>
        </b-card>
      </b-col>

      <b-col>
        <b-card>
          <h4>Submission Status</h4>

          <b-table-lite
            :items="submissionStatusInfoRows"
            striped
            small
            bordered
            thead-class="d-none"
          />
        </b-card>
      </b-col>
    </b-row>

    <SubmissionDetailCardstack :submission="submission" />
  </div>
</template>

<script>
import DefaultHeading from '@/components/shared/DefaultHeading'
import LoadingOverlay from '@/components/shared/LoadingOverlay'
import SubmissionModel from '@/models/lab/SubmissionModel'
import moment from 'moment'
import SubmissionDetailCardstack from '@/components/submissions/SubmissionDetailCardstack'

export default {
  name: 'SubmissionDetail',
  components: {
    DefaultHeading,
    LoadingOverlay,
    SubmissionDetailCardstack
  },
  data () {
    return {
      submission_id: this.$route.params.id,
      loading: true,
      submission: null
    }
  },
  computed: {
    submissionInfoRows () {
      const rows = []

      if (this.submission) {
        rows.push(
          {
            label: 'Identifier',
            value: this.submission.identifier
          },
          {
            label: 'Event Code',
            value: this.submission.event_code
          },
          {
            label: 'Created On',
            value: moment(this.submission.created_at).format('L')
          }
        )

        if (this.submission.submission_soil) {
          rows.push({
            label: 'Field',
            value: this.submission ? this.submission.identifier : 'Not Specified'
          })
          rows.push({
            label: 'Grower',
            value: this.submission.submission_soil.grower
              ? this.submission.submission_soil.grower
              : 'Not Specified'
          })
          if (this.submission.submission_soil.zone) {
            rows.push({
              label: 'Zone',
              value: this.submission.submission_soil.zone
            })
          }
        } else if (this.submission.submission_tissue) {
          rows.push({
            label: 'Field',
            value: this.submission ? this.submission.identifier : 'Not Specified'
          })
          rows.push({
            label: 'Crop',
            value: this.submission.submission_tissue.crop
              ? this.submission.submission_tissue.crop
              : 'Not Specified'
          })
          rows.push({
            label: 'Crop Stage',
            value: this.submission.submission_tissue.cropstage
              ? this.submission.submission_tissue.cropstage
              : 'Not Specified'
          })
        } else {
          rows.push({
            label: 'Identifier',
            value: this.submission ? this.submission.identifier : 'Not Specified'
          })
        }

        if (this.submission.submission_soil.zone) {
          rows.push(
            {
              label: 'Zone',
              value: this.submission.submission_soil.zone.name
            }
          )
        }
      }

      return rows
    },
    submissionStatusInfoRows () {
      const rows = []

      if (this.submission) {
        this.submission.submission_status_logs.forEach(log => {
          rows.push({
            label: log.submission_status.status,
            value: moment(log.created_at).format('L')
          })
        })
      }

      return rows
    }
  },
  mounted () {
    this.fetchSubmission()
  },
  methods: {
    fetchSubmission () {
      const model = new SubmissionModel({ id: this.submission_id })
      model.fetch().then(() => {
        this.submission = model
        this.loading = false
      })
    }
  }
}
</script>
